import React, {Fragment, useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import './Game.css';
import Menu from "../../Components/Menu/Menu";
import GamePin from "./GamePin/GamePin";
import InviteUsers from "./InviteUsers/InviteUsers";

const Game = () => {

    const location = useLocation();

    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [pinOpen, setPinOpen] = useState(false);
    // const [inviteOpen, setInviteOpen] = useState(false);
    const [codeInput, setCodeInput] = useState(null);

    useEffect(() => {
        axios.get(`/api/my_name/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                // setAuth(true);
                setName(res.data.name);
                console.log(res.data.name);
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
                // else {
                //     setAuth(false);
                //     // setAuth(true); // delete after
                // }
            })
    }, [setName]);

    const date = location.state?.date;
    const weekday = location.state?.weekday;
    const time = location.state?.time;
    const active = location.state?.active;
    const cort = location.state?.cort;
    const gameId = location.state?.gameId;

    // const date = '19 сентября 2025';
    // const weekday = 'Понедельник';
    // const time = '18:00';
    // const active = false;
    // const cort = 2;

    const openPinEnter = () => {
        axios.get(`/api/send/${gameId}/`, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true
        })
            .then(res => {
                console.log(res.data.detail);
                setCodeInput(res.data.detail);

                setPinOpen(true);
            })
            .catch(e => {
                console.log(e);
                alert(`Ваша игра начинается в ${time}, пожалуйста подождите`);
            })
    }

    const endGame = () => {
        axios.get(`/api/end/${gameId}/`, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true
        })
            .then(res => {
                console.log(res.data.detail);
                alert('Игра успешно завершена');
                navigate('/profile');
            })
            .catch(e => {
                console.log(e);
                if (e.status === 418) {
                    alert('Вы ещё не начали игру');
                } else {
                    alert('Ошибка сети');
                }
            })
    }

    const backToMyGames = () => {
        navigate('/profile');
    }

    // const openInviteUser = () => {
    //     setInviteOpen(true);
    // }

    return (
        <div className={'game-container'}>
            <Menu />
            <div className={'game-photo-name'}>
                <div className={'game-user-photo'}></div>
                <p className={'game-user-name'}>{name}</p>
            </div>
            <div className={'game-title'}>Моя игра:</div>
            <div className={'game-logo-and-info'}>
                <div className={'game-logo'}></div>
                <div className={'game-info'}>
                    <p className={'game-info-today'}>{active ? 'сегодня' : ''}</p>
                    <p className={'game-info-date'}>{date}</p>
                    <p className={'game-info-weekday-time'}>{weekday}, {time}</p>
                    <p className={'game-info-weekday-time'}>Корт №{cort}</p>
                </div>
            </div>
            {!pinOpen &&
                <Fragment>
                    <div className={`game-open-button ${!active ? 'game-open-button-disabled' : ''}`}
                         onClick={() => openPinEnter()}>
                        <p className={'game-open-button-text'}>Открыть дверь</p>
                    </div>
                    <div className={`game-end-button ${!active ? 'game-end-button-disabled' : ''}`}
                         onClick={() => endGame()}>
                        <p className={'game-end-button-text'}>Завершить игру</p>
                    </div>
                    <div className={`game-back-button`}
                         onClick={() => backToMyGames()}>
                        <p className={'game-back-button-text'}>Мои игры</p>
                    </div>
                </Fragment>
            }

            {/*{!inviteOpen &&*/}
            {/*    <div className={'invite-open-button'} onClick={() => openInviteUser()}>*/}
            {/*        <p className={'invite-open-button-text'}>Пригласить!</p>*/}
            {/*    </div>*/}
            {/*}*/}

            {pinOpen && <GamePin code={codeInput} isModalOpen={setPinOpen} />}

            {/*{inviteOpen && <InviteUsers open={setInviteOpen} />}*/}

        </div>
    );
};

export default Game;